import { Route, Routes } from 'react-router-dom';
import { Home } from './views/Home';
import { Squad } from './views/Squad';

export const AppRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/squad/:squadName' element={<Squad />} />
      </Routes>
    </div>
  );
};
